class PlaylistTypes {
	static Invalid = 0;
	static Schedule = 1;
	static SpotBlock = 2;
	static ClockTemplate = 3;
	static FillContent = 4;
	static Traffic = 5;
	static Emergency = 6;
	static HotKeyBank = 7;
	static NetworkSpotBlock = 8;
	static Pending = 11;	//???
	static SpecialShow = 13;
	static LocalBreak = 15;
	static DVTBlock = 16;
}

export default PlaylistTypes;